<template>
	<div @click="updatePaymentMethod" :class="this.activePaymentMethod === this.paymentType ? 'payment-method active-payment' : 'payment-method'">
		<div class="card-radio">
			<label class="radio-container"
				>{{ paymentType }}
				<span class="icon"></span>
			</label>
		</div>
		<div class="card-text">
			<div class="paragraph">{{ text }}</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "payment-method",
	components: {},
	props: ["paymentType", "text", "activePaymentMethod", "label", "changePayment"],
	methods: {
		updatePaymentMethod() {
			this.changePayment(this.paymentType);
		},
	},
};
</script>

<style scoped lang="scss">
.payment-method {
	padding: 30px 35px;
	text-align: left;
	border: 1px solid #dbdee7;
	border-radius: 6px;
	.header4 {
		color: var(--dark-gray);
	}
	.paragraph {
		color: var(--dark-gray);
		margin-top: 15px;
	}
}
.active-payment {
	background-color: var(--dark-blue);
	label,
	.header4,
	.paragraph {
		color: var(--white);
	}
}
.radio-container {
	display: block;
	position: relative;
	// padding-left: 35px;
	padding-left: 45px;
	margin-bottom: 12px;
	cursor: pointer;
	font-size: 22px;
}
.radio-container input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
}
.icon {
	position: absolute;
	top: 0;
	left: 0;
	height: 25px;
	width: 25px;
	border-radius: 50%;
	border: 1px solid #dbdee7;
	border: 1px solid #dbdee7;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin-top: 3px;
}
.active-payment .card-radio .radio-container span.icon {
	background-color: var(--white);
}
.icon:after {
	content: "";
	position: absolute;
	display: none;
}
.active-payment .card-radio .radio-container span.icon:after {
	display: block;
	width: 12px;
	height: 12px;
	border-radius: 50%;
	background: var(--primary);
}
@media screen and (max-width: 414px) {
	.payment-method {
		width: unset;
		padding: 47px 16px;
		display: block;
		margin-right: unset;
	}
}
</style>
